import { Inertia } from '@inertiajs/inertia'
import { InertiaLink } from '@inertiajs/inertia-react'
import EditIcon from '@mui/icons-material/Edit'
import PageviewIcon from '@mui/icons-material/Pageview'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import { useTranslation } from 'react-i18next'
import ButtonChangeStatus from '../../../../components/ButtonChangeStatus'
import DataGrid from '../../../../components/organisms/DataGrid/DataGrid'
import { STATUS } from '../../../../constant/StatusConstant'

export default function PartnerIndex({ partners }) {
  const { t } = useTranslation()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DataGrid
          enableIndexColumn
          columns={[
            {
              id: 'name',
              Header: t('PARTNER.NAME'),
              accessor: 'name',
              type: 'string',
            },

            {
              id: 'campaigns_count',
              Header: t('PARTNER.CAMPAIGNS'),
              accessor: 'campaigns_count',
              type: 'number',
              autoHide: true,
            },
            {
              id: 'vouchers_count',
              Header: t('CAMPAIGN.TOTAL_VOUCHERS'),
              accessor: 'vouchers_count',
              type: 'number',
            },

            {
              id: 'vouchers_cost',
              Header: t('CAMPAIGN.TOTAL_COST'),
              accessor: 'vouchers_cost',
              type: 'number',
              autoHide: true,
              disableFilters: true,
            },
            {
              id: 'status',
              Header: t('PARTNER.STATUS'),
              accessor: ({ status }) => t(`PARTNER.${status.toUpperCase()}`),
              type: 'singleSelect',
              options: [
                { value: STATUS.ACTIVE, name: t('PARTNER.ACTIVE') },
                { value: STATUS.IN_ACTIVE, name: t('PARTNER.INACTIVE') },
              ],
              Cell: ({ row }) => (
                <ButtonChangeStatus
                  handleSubmit={() => {
                    const status = row.original.status === STATUS.ACTIVE ? STATUS.IN_ACTIVE : STATUS.ACTIVE
                    Inertia.get(route('admin.partners.status.change', { partner: row.original.id, status }))
                  }}
                  row={row}
                  tableName={t('PARTNER.PARTNER_TABLE')}
                />
              ),
            },
            {
              id: 'actions',
              Header: t('PARTNER.ACTIONS'),
              align: 'center',
              cell: {
                style: { whiteSpace: 'nowrap' },
              },
              disableFilters: true,
              Cell: ({ row }) => (
                <>
                  <IconButton component={InertiaLink} href={route('admin.partners.show', row.original.id)}>
                    <PageviewIcon />
                  </IconButton>
                  <IconButton component={InertiaLink} href={route('admin.partners.edit', row.original.id)}>
                    <EditIcon />
                  </IconButton>
                </>
              ),
            },
          ]}
          data={partners}
          routeName="admin.partners.index"
        />
      </Grid>
    </Grid>
  )
}
